import * as React from "react";
import Partner from "../../../classes/Partner";
import AppContext from "../AppContext";
import api from "../../api";
import Lead from "../../../classes/Lead";
import Section from "../Section/Section";
import { _t } from "../../../utils/Translator";

type OpportunitySectionProps = {
  partner: Partner;
  canCreatePartner: boolean;
};

type OpportunitySectionState = {
  opportunities: Lead[];
};

class SectionOpportunities extends React.Component<OpportunitySectionProps, OpportunitySectionState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      opportunities: (this.props.partner.leads || []).filter(
        lead => !lead.type || lead.type === "opportunity"
      )
    };
  }

  private getOpportunityDescription = (lead: Lead): string => {
    return _t(
      lead.recurringPlan
        ? "%(expected_revenue)s + %(recurring_revenue)s %(recurring_plan)s at %(probability)s%"
        : "%(expected_revenue)s at %(probability)s%",
      {
        expected_revenue: lead.expectedRevenue,
        recurring_revenue: lead.recurringRevenue,
        recurring_plan: lead.recurringPlan,
        probability: lead.probability
      }
    );
  };

  render() {
    return (
      <Section
        records={this.state.opportunities}
        partner={this.props.partner}
        canCreatePartner={this.props.canCreatePartner}
        model="crm.lead"
        odooEndpointCreateRecord={api.createLead}
        odooRecordIdName="lead_id"
        odooRedirectAction="crm_mail_plugin.crm_lead_action_form_edit"
        onClickCreate={callback => callback({ type: "opportunity" })}
        title="Opportunities"
        titleCount="Opportunities (%(count)s)"
        msgNoPartner="Save Contact to create new Opportunities."
        msgNoPartnerNoAccess="The Contact needs to exist to create Opportunity."
        msgNoRecord="No opportunities found for this contact."
        msgLogEmail="Log Email Into Opportunity"
        getRecordDescription={this.getOpportunityDescription}
      />
    );
  }
}

SectionOpportunities.contextType = AppContext;

export default SectionOpportunities;
